module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/readable-stream/passthrough.js
// module id = 1441
// module chunks = 7